const contactInfo = {
  phone: "(573) 353-1336",
  email: "bwoodward23@live.com"
};

export default contactInfo;
